import http, { authHeader } from './http';

// Получение профиля текущего авторизованного пользователя
export const getProfile = async (token) => {
  const response = await http.get('/api/profile', { headers: authHeader(token) });
  return response.data;
};

// Обновление профиля пользователя
export const updateProfile = async (token, profileData) => {
  const response = await http.put('/api/profile', profileData, { headers: authHeader(token) });
  return response.data;
};

// Смена пароля пользователя
export const changePassword = async (token, oldPassword, newPassword) => {
  const response = await http.put(
    '/api/profile/password',
    { oldPassword, newPassword },
    { headers: authHeader(token) }
  );
  return response.data;
};

// Статус автопродления (активные подписки CloudPayments)
export const getSubscription = async (token) => {
  const response = await http.get('/api/profile/subscription', { headers: authHeader(token) });
  return response.data;
};

// Отключение автопродления — доступ сохраняется до конца оплаченного периода
export const cancelSubscription = async (token) => {
  const response = await http.post('/api/profile/subscription/cancel', {}, { headers: authHeader(token) });
  return response.data;
};
